export default {
  "content": "<path d=\"M240 80l8 240h16l8-240h-32zm0 320h32v32h-32z\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};